import axiosClient from "@/api/common/axiosClient.ts";
import { AuthenticationResponse } from "@/types/authentication.ts";

export const checkRegistration = ({ email }: { email: string }) => {
  return axiosClient.post<{
    status: "already-exist" | "already-exist-on-another-client" | "new-user";
  }>("users/check_registration/", {
    email,
  });
};

export const connectToNewClient = ({
  email,
  password,
  signupAnswer,
}: {
  email: string;
  password: string;
  signupAnswer?: string | null;
}) => {
  return axiosClient.post<AuthenticationResponse>("users/connect/", {
    email,
    password,
    signup_answer: signupAnswer,
  });
};

export type ConnectToNewClientErrorType =
  | { detail: string }
  | { email: string }
  | { user: string }
  | { signup_answer: string[] };

export const signUp = ({
  email,
  clubCode,
  name,
  phoneNumber,
  dateOfBirth,
  password,
  passcode,
  signupAnswer,
}: {
  email: string;
  clubCode?: string;
  name: string;
  phoneNumber: string;
  dateOfBirth: string;
  password: string;
  passcode?: string;
  signupAnswer?: string | null;
}) => {
  return axiosClient.post<AuthenticationResponse>("users/register/", {
    email,
    password,
    confirm_password: password,
    passcode,
    date_of_birth: dateOfBirth,
    phone_number: phoneNumber,
    club_code: clubCode,
    name,
    signup_answer: signupAnswer,
  });
};
